import { render, staticRenderFns } from "./btnGoTop.vue?vue&type=template&id=e3e49eba&scoped=true"
import script from "./btnGoTop.ts?vue&type=script&lang=ts&external"
export * from "./btnGoTop.ts?vue&type=script&lang=ts&external"
import style0 from "./btnGoTop.vue?vue&type=style&index=0&id=e3e49eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e49eba",
  null
  
)

export default component.exports